import { Button, Skeleton } from '@paguz/ui';
import { Link } from '@tanstack/react-router';
import { ProgressBar, percentOf } from '../../components/progress-bar.tsx';
import { useCurrentApplication } from './hooks.ts';
import { PHASE_LABEL } from './labels.ts';

/** Tarjeta de Inicio para quien tiene una solicitud en curso (sin cupo todavía). */
export function ApplicationHomeCard() {
  const application = useCurrentApplication();
  if (application.isPending) return <Skeleton className="h-40 w-full rounded-2xl" />;
  if (application.isError || application.data === null) return null;
  const data = application.data;
  const percent = percentOf(data.completeness);
  const approved = data.offer?.status === 'PRESENTED';
  return (
    <section
      aria-label="Tu solicitud de crédito"
      className="flex flex-col gap-3 rounded-2xl bg-highlight-soft p-5 text-highlight-soft-foreground"
    >
      <h2 className="text-xl">
        {approved ? '¡Tu crédito fue aprobado!' : 'Tu solicitud de crédito'}
      </h2>
      <p className="text-sm">
        Vas en <strong>{PHASE_LABEL[data.phase]}</strong> · {percent} %
      </p>
      <ProgressBar value={percent} label="Avance de la solicitud" className="bg-card" />
      <div className="grid grid-cols-2 gap-2">
        <Button asChild variant="highlight">
          {approved || data.phase === 'FORMALIZATION' ? (
            <Link to="/solicitud/oferta">Ver oferta</Link>
          ) : (
            <Link to="/asesor" search={{ agente: 'asesor' }}>
              Continuar
            </Link>
          )}
        </Button>
        <Button asChild variant="outline">
          <Link to="/solicitud">Mi solicitud</Link>
        </Button>
      </div>
    </section>
  );
}
